import React, { useEffect, useState, useContext } from "react";
import styles from "./Programs.module.scss";
import "react-toastify/dist/ReactToastify.css";
import CheckedIcon from "../../../assets/svg/CheckedIcon.svg";
import UnCheckedIcon from "../../../assets/svg/UnCheckedIcon.svg";
import ProgramGraphQuery from "../Graphs/ProgramGraphQuery";
import EditQuery from "../../../assets/images/EditQuery.svg";
import QueryModal from "../QueryModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GetBaseUrl from "../../../functions/SetBaseUrl";
import axios from "axios";
import { GetAPISavedGraphQuery } from "../../../functions/GetAPIList";
import FilterName from "../../../components/Atoms/FilterName";
import FilterNameTab from "../../../components/Atoms/FilterNameTab";

import comparisonStyles from "../../../pages/AUD_DashboardPrivate.module.scss";

export const Programs = ({
  queryResult,
  QS,
  reloadDashboard,
  setEditMode,
  editMode,
  viewQueryResult,
  selectedFilters,
  filter1Name,
  filter2Name,
  setFilter1Name,
  setFilter2Name,
  setSelectedFilters,
  comparisonMode,
  setSelectedOptionalFilterData,
  comparisonTabs,
  setActiveComparisonTab,
  selectedComparisonFilters,
}) => {
  //---------------------------------------------------------------------
  const [tabIndex, setTabIndex] = useState(41);
  const [percentage, setPercentage] = useState(true);
  const BaseUrl = GetBaseUrl()[0];
  var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

  //------------------------------------------------------------
  const [selectedInternalFilters, setSelectedInternalFilters] = useState();
  const [askQueryModal, setAskQueryModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [query, setQuery] = useState(null);
  const getObjByKey = (array, i, key) => {
    const item = array.find((element) => element[key] === i);
    return item ? item : "";
  };

  let queryStructures2_1 = `Select
Count 
Where - program_type='Undergraduate'
Group By - programdescrip,my_status`;

  let queryStructures2_2 = `Select
Count 
Where - program_type='Graduate'
Group By - programdescrip,my_status`;

  let queryStructures2_3 = `Select
Count 
Where - program_type='Others'
Group By - programdescrip,my_status`;

  const [programCharts, setProgramCharts] = useState([
    {
      index: [41],
      titles: [],
      key: 41,
      widgetType: ["LineStackPercentageGroupGraph"],
      graphType: "bar",
      seriesTitles: [
        "Applicant Pending - Reject",
        "Application Closed",
        "Cancel",
        "Enrolled",
        "No Show",
        "Postpone",
        "Reject",
      ],
      max: 100,
      height: 480,
      title: "",
      stacked: true,
      pre: "",
      options: [queryStructures2_1],
    },
    {
      index: [42],
      titles: [],
      key: 42,

      widgetType: ["LineStackPercentageGroupGraph"],
      graphType: "bar",
      seriesTitles: [
        "Applicant Pending - Reject",
        "Application Closed",
        "Cancel",
        "Enrolled",
        "No Show",
        "Postpone",
        "Reject",
      ],
      max: 100,
      height: 480,
      title: "",
      stacked: true,
      pre: "",
      options: [queryStructures2_2],
    },
    {
      index: [43],
      titles: [],
      key: 43,

      widgetType: ["LineStackPercentageGroupGraph"],
      graphType: "bar",
      seriesTitles: [
        "Applicant Pending - Reject",
        "Application Closed",
        "Cancel",
        "Enrolled",
        "No Show",
        "Postpone",
        "Reject",
      ],
      max: 100,
      height: 480,
      title: "",
      stacked: true,
      pre: "",
      options: [queryStructures2_3],
    },
  ]);
  const [defaultQueryStructure, setDefaultQueryStructure] = useState(
    programCharts[0].options[0]
  );

  //----------------------------------------------------
  useEffect(() => {
    const SavedGraphQuery = async () => {
      let qName = "";
      let qReportId = 0;
      let qQuery = "";
      try {
        const data = await GetAPISavedGraphQuery("AUD");

        for (let i = 0; i < data.length; i++) {
          const element = data[i];

          if (element.queryId === tabIndex) {
            qName = element.queryName;
            qReportId = element.reportId;
            qQuery = element.queryText;
          }
        }

        setQuery({
          queryName: qName,
          reportId: qReportId,
          query: qQuery,
        });
      } catch (error) {
        console.error("Error :", error);
      }
    };
    SavedGraphQuery();

    !comparisonMode && viewQueryResult([tabIndex], selectedFilters);

    comparisonMode &&
      comparisonTabs &&
      comparisonTabs[0].active &&
      viewQueryResult([tabIndex], selectedFilters);

    comparisonMode &&
      comparisonTabs &&
      comparisonTabs[1].active &&
      viewQueryResult([tabIndex], selectedComparisonFilters);

    // comparisonMode && viewQueryResult([tabIndex], selectedInternalFilters);
  }, [tabIndex, percentage]);

  //---------------------------------------------------

  const handleSave = () => {
    let Query = {
      queryId: tabIndex,
      queryType: "report",
      widgetType: getObjByKey(programCharts, tabIndex, "key").widgetType[0],
      queryName: query.queryName,
      queryText: query.query,
      reportId: query.reportId,
      tableId: "00000000-0000-0000-0000-000000000000",
      columnId: "00000000-0000-0000-0000-000000000000",
      platformName: "AUD",
    };
    // console.log(Query);
    if (query.queryName && query.query && query.reportId) {
      axios
        .post(BaseUrl + "/Report/InsertReportQuery", Query, {
          headers: {
            Authorization: `Bearer ${token}`,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          toast.success("Query has been added", {
            position: toast.POSITION.TOP_RIGHT,
          });
          viewQueryResult([tabIndex], selectedFilters);
        })
        .catch((res) => {
          toast.error(res + "", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .finally(() => {});
      return true;
    } else {
      toast.warning("Enter required values", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
  };

  //----------------------------------------------
  useEffect(() => {
    // console.log(11111111);

    comparisonMode &&
      comparisonTabs &&
      comparisonTabs[0].active &&
      viewQueryResult([tabIndex], selectedFilters);

    !comparisonMode && viewQueryResult([tabIndex], selectedFilters);
  }, [selectedFilters]);

  useEffect(() => {
    // console.log(2222222);

    viewQueryResult([tabIndex], selectedInternalFilters);
  }, [selectedInternalFilters]);
  //--------------------------------
  const [Filter1, setFilter1] = useState(filter1Name && filter1Name);
  const [Filter2, setFilter2] = useState(filter2Name && filter2Name);

  useEffect(() => {
    setFilter1(filter1Name);
  }, [filter1Name]);

  useEffect(() => {
    setFilter2(filter2Name);
  }, [filter2Name]);

  //---------------------
  useEffect(() => {
    selectedComparisonFilters &&
      comparisonMode &&
      comparisonTabs &&
      comparisonTabs[1].active &&
      viewQueryResult([tabIndex], selectedComparisonFilters);
  }, [selectedComparisonFilters]);
  //---------------------
  useEffect(() => {
    !comparisonMode && viewQueryResult([tabIndex], selectedFilters);
    !comparisonMode &&
      setActiveComparisonTab(comparisonTabs, comparisonTabs[0].title);
  }, [comparisonMode]);
  //----------------------------------------------------

  return (
    <>
      <div className={`${comparisonStyles.FullyContainer100} `}>
        {comparisonTabs && comparisonMode && (
          <div className={`${comparisonStyles.comparisonTabsContainer} row`}>
            {comparisonTabs.map((tab, i) => {
              return (
                <div
                  key={tab.title}
                  className={`${comparisonStyles.tab} ${
                    tab.active ? comparisonStyles.active : ""
                  } `}
                  style={{ width: tab.width }}
                  onClick={() => {
                    setActiveComparisonTab(comparisonTabs, tab.title);
                    setPercentage(true);
                  }}
                >
                  <FilterNameTab
                    filter={
                      !i && Filter1 ? Filter1 : i && Filter2 ? Filter2 : ""
                    }
                    filterType={
                      !i && Filter1
                        ? "normal"
                        : i && Filter2
                        ? "comparison"
                        : ""
                    }
                    setFilter1Name={setFilter1}
                    setFilter2Name={setFilter2}
                    setSelectedInternalFilters={setSelectedInternalFilters}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className={`${styles.container} row `}>
        <h4>Programs</h4>
        <div className={`${styles.selectContainer} row `}>
          <span
            className={`${styles.programType}  ${
              tabIndex === 41 && styles.active
            }`}
            onClick={() => {
              setTabIndex(41);
              setDefaultQueryStructure(programCharts[0].options[0]);
              setPercentage(true);
            }}
          >
            Undergraduate
            {editMode && (
              <>
                <img
                  src={EditQuery}
                  onClick={() => setAskQueryModal(true)}
                  className={`${styles["EditQuery"]}`}
                  alt="EditQuery"
                />
              </>
            )}{" "}
          </span>

          <span
            className={`${styles.programType} ${
              tabIndex === 42 && styles.active
            }`}
            onClick={() => {
              setTabIndex(42);
              setDefaultQueryStructure(programCharts[1].options[0]);
              setPercentage(true);
            }}
          >
            Graduate
            {editMode && (
              <>
                <img
                  src={EditQuery}
                  onClick={() => setAskQueryModal(true)}
                  className={`${styles["EditQuery"]}`}
                  alt="EditQuery"
                />
              </>
            )}{" "}
          </span>
          {/* <span
            className={`${styles.programType} ${
              tabIndex === 43 && styles.active
            }`}
            onClick={() => {
              setTabIndex(43);
              setDefaultQueryStructure(programCharts[2].options[0]);
              setPercentage(true);
            }}
          >
            Others
            {editMode && (
              <>
                <img
                  src={EditQuery}
                  onClick={() => setAskQueryModal(true)}
                  className={`${styles["EditQuery"]}`}
                  alt="EditQuery"
                />
              </>
            )}{" "}
          </span> */}
        </div>{" "}
        <div className={`${styles.percentage} `}>
          <img
            src={percentage ? CheckedIcon : UnCheckedIcon}
            alt="CheckedIcon"
            onClick={() => setPercentage(!percentage)}
          />{" "}
          <span>Percentage</span>
        </div>
        <div className={`${styles.programCharts} `}>
          {programCharts &&
            programCharts.map((graph) => {
              return (
                <ProgramGraphQuery
                  percentage={percentage}
                  showGraph={graph.index.indexOf(tabIndex) > -1}
                  fullWidthContainer
                  withTabs={false}
                  data={queryResult}
                  setEditMode={setEditMode}
                  editMode={false}
                  viewQueryResult={viewQueryResult}
                  reloadDashboard={reloadDashboard}
                  key={graph.index}
                  height={graph.height}
                  title={graph.title}
                  widgetType={graph.widgetType}
                  index={graph.index}
                  titles={graph.titles}
                  graphType={["bar"]}
                  // graphType={graph.graphType}
                  queryStructures={graph.options}
                  seriesTitles={graph.seriesTitles}
                  max={graph.max}
                  stacked={graph.stacked}
                  pre={graph.pre}
                  maxCategoryLength={20}
                />
              );
            })}
        </div>
        {askQueryModal ? (
          <QueryModal
            setAskQueryModal={setAskQueryModal}
            query={query}
            setQuery={setQuery}
            handleSave={handleSave}
            setCategories={setCategories}
            setSeries={setSeries}
            categories={[]}
            series={[]}
            defaultQueryStructure={defaultQueryStructure}
          />
        ) : null}
      </div>
    </>
  );
};
